<template>
  <div :id="name">
    <span v-for="(option, index) in options" :key="index">
      <span v-show="!filter || filterCheck(option)">
        <input-checkbox
          :name="`${name}_opt_${index}`"
          :label="option.label"
          :checked="option.checked || false"
          :disabled="isOptionDisabled(option)"
          @input="(evt) => handleInput(evt, option)" />
      </span>
    </span>
  </div>
</template>

<script>
import InputCheckbox from '@/components/InputCheckbox/InputCheckbox.vue';

export default {
  name: 'checkbox-group',
  components: {
    'input-checkbox': InputCheckbox,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    maxItems: {
      type: [Number, String],
    },
    filter: {
      type: Function,
    },
  },
  data: () => ({
    selectedOptions: [],
  }),
  watch: {
    '$attrs.value': function setItems(newValue) {
      this.selectedOptions = newValue;
    },
  },
  created() {
    this.selectedOptions = this.$attrs.value;
  },
  mounted() {
    // Checa se existe outro elemento com mesmo ID e lança um warning caso encontre.
    const elementsWithId = document.querySelectorAll(`#${this.name}`);
    if (elementsWithId.length > 1) {
      console.warn(`Atenção: existe outro elemento com ID "${this.name}"! Efeitos colaterais inesperados podem ocorrer.`, elementsWithId);
    }
  },
  methods: {
    isOptionDisabled(option) {
      if (option.disabled) return true;
      if (this.maxItems) {
        return (this.selectedOptions.length < this.maxItems)
          ? false
          : !this.selectedOptions.includes(option.value);
      }
      return false;
    },
    filterCheck(option) {
      return this.filter(option);
    },
    handleInput(event, option) {
      if (event.target.checked) {
        this.selectedOptions.push(option.value);
      } else {
        this.selectedOptions = this.selectedOptions.filter((value) => value !== option.value);
      }

      this.$emit('input', this.selectedOptions);
    },
  },
};
</script>
